module.exports = __webpack_public_path__ + "static/food-4eb22e280b186c5a396c1bd8c1bf7a5c.jpg";